import React from 'react';
import {TextField, Autocomplete, FormControl, Box, Typography} from '@mui/material';
const JudgeSelector = ({ judgesList, edit, selectedJudges, onChange, selector_type="JJ" }) => {
    const handleChange = (type, newValue) => {
        onChange({
            ...selectedJudges,
            [type]: newValue.map(judge => judge._id),
        });
    };

    const getSelected = (type) => {
        return judgesList.filter(j => selectedJudges[type]?.includes(j._id));
    };

    return (
        selector_type === "JJ" ?
        <Box sx={{ width:280, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6">Выбор судей</Typography>
            <FormControl>
                <Autocomplete
                    multiple
                    options={judgesList}
                    getOptionLabel={(option) => `${option.name} (${option.email})`}
                    disabled={!edit}
                    value={getSelected("leaders")}
                    onChange={(event, newValue) => handleChange("leaders", newValue)}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderInput={(params) => (
                        <TextField {...params} label="Судьи для лидеров" placeholder="leaders" />
                    )}
                />
            </FormControl>
            <FormControl>
                <Autocomplete
                    multiple
                    options={judgesList}
                    getOptionLabel={(option) => `${option.name} (${option.email})`}
                    disabled={!edit}
                    value={getSelected("followers")}
                    onChange={(event, newValue) => handleChange("followers", newValue)}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderInput={(params) => (
                        <TextField {...params} label="Судьи для фолловеров" placeholder="followers" />
                    )}
                />
            </FormControl>
        </Box>:
            <Box sx={{ width:280, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">Выбор судей</Typography>
                <FormControl>
                    <Autocomplete
                        multiple
                        options={judgesList}
                        getOptionLabel={(option) => `${option.name} (${option.email})`}
                        disabled={!edit}
                        value={getSelected("leaders")}
                        onChange={(event, newValue) => handleChange("leaders", newValue)}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        renderInput={(params) => (
                            <TextField {...params} label="Судьи" placeholder="Судьи" />
                        )}
                    />
                </FormControl>
            </Box>
    );
};
export default JudgeSelector;
